import {useCallback, useEffect, useState} from 'react';
import {accountsApi, authStorage} from '../services/api';

export default function useAuthRole() {
    const [role, setRole] = useState(authStorage.getRole());
    const [capabilities, setCapabilities] = useState(authStorage.getCapabilities());
    const [isRoleLoading, setIsRoleLoading] = useState(!authStorage.getRole());

    const syncRole = useCallback(() => {
        setRole(authStorage.getRole());
        setCapabilities(authStorage.getCapabilities());
    }, []);

    useEffect(() => {
        let isMounted = true;

        const loadRole = async () => {
            if (!authStorage.isAuthenticated()) {
                if (isMounted) setIsRoleLoading(false);
                return;
            }
            const storedUser = authStorage.get().user || {};
            const storedRole = authStorage.getRole();
            const hasCurrentAccessContract = [
                'is_teacher', 'is_student', 'is_organization_master',
            ].every((field) => Object.prototype.hasOwnProperty.call(storedUser, field)) && (
                Object.prototype.hasOwnProperty.call(storedUser, 'isPlatformAdmin') ||
                Object.prototype.hasOwnProperty.call(storedUser, 'is_platform_admin')
            );
            if (storedRole && hasCurrentAccessContract) {
                if (isMounted) {
                    setRole(storedRole);
                    setCapabilities(authStorage.getCapabilities());
                    setIsRoleLoading(false);
                }
                return;
            }

            try {
                await accountsApi.profile();
            } catch {
                // Authentication failures are handled by the shared API layer.
            } finally {
                if (isMounted) {
                    setRole(authStorage.getRole());
                    setCapabilities(authStorage.getCapabilities());
                    setIsRoleLoading(false);
                }
            }
        };

        loadRole();
        window.addEventListener('auth-change', syncRole);
        window.addEventListener('storage', syncRole);
        return () => {
            isMounted = false;
            window.removeEventListener('auth-change', syncRole);
            window.removeEventListener('storage', syncRole);
        };
    }, [syncRole]);

    return {
        role,
        ...capabilities,
        isRoleLoading,
        switchRole: authStorage.setActiveRole,
    };
}
